import { useState, useCallback } from "react";

export function usePulseAnimation() {
  const [animatedFields, setAnimatedFields] = useState<Set<string>>(new Set());

  const triggerAnimation = useCallback(
    (field: string, durationMs: number = 600) => {
      setAnimatedFields((prev) => new Set(prev).add(field));

      setTimeout(() => {
        setAnimatedFields((prev) => {
          const next = new Set(prev);
          next.delete(field);
          return next;
        });
      }, durationMs);
    },
    []
  );

  const triggerMultiple = useCallback(
    (fields: string[], durationMs: number = 1000) => {
      setAnimatedFields((prev) => new Set([...prev, ...fields]));

      setTimeout(() => {
        setAnimatedFields((prev) => {
          const next = new Set(prev);
          fields.forEach((field) => next.delete(field));
          return next;
        });
      }, durationMs);
    },
    []
  );

  const getAnimationClass = useCallback(
    (field: string): string => {
      return animatedFields.has(field)
        ? "animate-pulse bg-brand-50 transition-all duration-500"
        : "";
    },
    [animatedFields]
  );

  return {
    triggerAnimation,
    triggerMultiple,
    getAnimationClass,
  };
}
